import { jwtDecode } from 'jwt-decode';
import { JobPricingReportConstants } from '../constants/JobPricingReportConstants';



export const classNames = (...classes: any[]): string => {
  return classes?.length ? classes.filter(Boolean).join(' ') : '';
};

//Type Guard Function
export const isString = (value: any): value is string => typeof value === 'string';

export const getUserName = (keycloakAuthState: any): string => {
  if (keycloakAuthState?.token) {
    const decodedToken: any = jwtDecode(String(keycloakAuthState?.token));
    const userName = (decodedToken?.idTokenParsed?.name as string) ?? '';

    return userName;
  }
  return '';
};
export const getTimeStamp = (dateInput = new Date()) => {
  const date = dateInput instanceof Date ? dateInput : new Date(dateInput);

  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, '0');
  const day = String(date.getDate()).padStart(2, '0');
  const hours = String(date.getHours()).padStart(2, '0');
  const minutes = String(date.getMinutes()).padStart(2, '0');
  const seconds = String(date.getSeconds()).padStart(2, '0');

  return `${year}${month}${day}${hours}${minutes}${seconds}`;
};

export const getCookie = (name: string) => {
  const value = `; ${document.cookie}`;
  const parts: any = value?.split(`; ${name}=`);
  if (parts?.length === 2) return parts.pop().split(';').shift();
  return null;
}


export const getPayloadLanguage = (): string => {
  const shortLangCode = sessionStorage.getItem('kfone_short_lang_code');
  return shortLangCode ? shortLangCode.toUpperCase() : 'EN';
};


export const getLanguageCode = (): string =>
  (
    sessionStorage.getItem('kfone_short_lang_code') ||
    JobPricingReportConstants.DEFAULT_LANGUAGE_CODE
  ).toUpperCase();